export default "__VITE_ASSET__DaGS8jx6__"